import { render } from "./Page9.vue?vue&type=template&id=52b59f68"
import script from "./Page9.vue?vue&type=script&lang=js"
export * from "./Page9.vue?vue&type=script&lang=js"

import "./Page9.vue?vue&type=style&index=0&id=52b59f68&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__